module.exports = __webpack_public_path__ + "static/media/patreon-logo-white.03345b4c.svg";